import Vue from "vue";
import Config from "@/config";
import {sortByAuth} from "@/utils/group";
import {date2Iso} from "@/utils/date";
import uiMutations from "@/store/ui/mutations";
import {
    sortAllContextsChildren
} from "@/utils/area";
import {appendContextFromPayload, applyAreaUpdateFromPayload, applyContextUpdateFromPayload} from "@/utils/task";

const mutations = {
    groupCreate: (state, payload) => {
        console.log("MUTATION group/create", payload);
        payload.mutation = "groupAppend";
    },
    groupAppend: (state, payload) => {
        console.log("MUTATION group/append", payload);

        /*if (payload?.isFromServer) {
            appendGroupFromPayload(state, payload);
        }*/

        /*if (!payload?.groupAppend) return;

        const item = payload?.groupAppend?.item;
        if (!item) return;

        const area = state.session.area;
        let items = area.groups;



        // insert item
        if (items?.findIndex(el => el.id === item.id) === -1) {
            items.unshift(item);
            console.log("GROUP APPENDED", item);
        }*/

    },
    groupDelete: (state, payload) => {
        console.log("groupDelete", payload);

        const contextId = payload?.contextId;
        if (!contextId) return;

        const area = state.session.area;
        let items = area.groups;
        // delete item
        let index = items?.findIndex(el => el.contextId === contextId);
        if (index >= 0) {
            items.splice(index, 1);
            console.log("GROUP DELETE", contextId);
        }
    },
    groupUpdate: (state, payload) => {
        console.log("MUTATION group/update", payload);

        if (payload.isFromServer) {
            applyContextUpdateFromPayload(state, payload);
            /*if (!payload?.groupUpdate?.item?.id) return;

            const update = (item, params) => {
                //console.log("== UPDATING GROUP " + item.name);
                Object.keys(params).forEach(key => {
                    //console.log("\t" + key + ":" + params[key]);
                    Vue.set(item, key, params[key]);
                });
            }

            const params = payload?.groupUpdate?.item;

            // update item in session
            //console.log("== UPDATING GROUPS");
            const items = state.session.area.groups;
            let item;
            if (items?.length) {
                item = items.find(el => el.auth === params.auth);
                if (item) update(item, params);
            }

            // update item in context
            //console.log("== UPDATING CONTEXT", state.page.context.item?.isGroup, state.page.context.item?.id);
            if (state.page.context.item?.isGroup && state.page.context.item.auth === params.auth) update(state.page.context.item, params);*/
        } else {
            /*            const auth = payload?.groupAuth || payload?.contextId;
                        if (!auth) return;
                        if (!payload?.params) return;

                        const update = (item) => {
                            //console.log("UPDATE GROUP "+item.name);
                            Object.keys(payload.params).forEach(key => {
                                Vue.set(item, key, payload.params[key]);
                            });
                        }

                        // update item in session
                        const items = state.session.area.groups;
                        let item;
                        if (items?.length) {
                            item = items.find(el => el.auth === auth);
                            if (item) update(item);
                        }

                        // update item in context
                        if (state.page.context.item?.isGroup && state.page.context.item.auth === auth) update(state.page.context.item);*/

        }
    },
    groupFav: (state, payload) => {
        console.log("MUTATION group/fav", payload);
        if (!payload?.params) return;

        // remove archivedAt if groupgoes to favs
        const params = payload.params;
        if (params.isFav) {
            params.isArchived = false;
            params.archivedAt = null;
        }

        mutations.groupUpdate(state, payload);
    },
    groupArchive: (state, payload) => {
        console.log("MUTATION group/archive", payload);
        if (!payload?.params) return;

        const params = payload.params;
        if (params.isArchived) {
            params.archivedAt = date2Iso(new Date());
            //params._isArchived = true;
            //params.isFav = false;
        } else {
            params.archivedAt = null;
            //params._isArchived = false;
        }

        mutations.groupUpdate(state, payload);
    },
    groupTaskSort: (state, payload) => {
        console.log("MUTATION group/taskSort", payload);

        const groupId = payload.groupId;
        const topicAuth = payload.topicAuth;
        if (!groupId && !topicAuth) return;

        const newTaskSort = payload.taskSort;
        if (!newTaskSort?.length) return;

        // check the requested context is ours
        let context;
        if (topicAuth && topicAuth === state.page.context.topic?.auth) context = state.page.context.topic;
        else if (!topicAuth && groupId && groupId === state.page.context.group?.id) context = state.page.context.group;
        else return;

        //console.log("CONTEXT topic", state.page.context.topic);
        //console.log("CONTEXT group", state.page.context.group);

        // apply to tasks
        const action = () => {
            const tasks = state.page.tasks.items;
            sortByAuth(tasks, newTaskSort);
        }

        // find which task is moved
        /*const sortedTab = state.page.context.tab;
        let currentTaskSort = context.taskSort;
        if ( typeof currentTaskSort === "string" ) {
            try { currentTaskSort = JSON.parse(currentTaskSort);}
            catch (e) {return;}
        }
        currentTaskSort = Array.isArray(currentTaskSort) ? currentTaskSort : currentTaskSort[sortedTab];
        const movedItem = newTaskSort.find((el, i)=>el !== currentTaskSort[i]);
        console.log("Moved item", movedItem);*/
        //uiMutations.uiSetActorOfGroupTaskSort(state, {userAuth: payload.userAuth});
        if (payload.initiatorAuth && payload.taskAuth) {
            uiMutations.uiSetActorOfTask(state, {
                userAuth: payload.userAuth,
                subjectAuth: payload.taskAuth,
                icon: "mdi-hand-back-right-outline",
                timeout: 900,
            });
            setTimeout(action, 300);
        } else action();

        // todo apply to context.taskSort
        //Vue.set(context, "taskSort", context.taskSort);
        //console.log("context.taskSort", context.taskSort);

        /*const sourceIndex = payload.sourceIndex;
        const destinationIndex = payload.destinationIndex;
        const items = state.page.tasks.items;

        if (!items) return;
        if (sourceIndex < 0 || sourceIndex >= items.length) return;
        if (destinationIndex < 0 || destinationIndex >= items.length) return;

        if (sourceIndex !== destinationIndex) {
            const source = items[sourceIndex];
            items.splice(sourceIndex, 1);
            items.splice(destinationIndex, 0, source);
        }*/

        // broadcast to subscribers of this
        const broadcast = [{
            entity: "group",
            auth: groupId,
        }];
        if (topicAuth) broadcast.push({
            entity: "topic",
            auth: topicAuth,
        });
        payload.broadcast = broadcast;
        console.log("broadcast", broadcast);
    },
    groupTopicSort: (state, payload) => {
        console.log("MUTATION group/topicSort", payload);

        const group = state.session.area.groups.find(el => el.id === payload.groupId);
        if (!group) return;

        sortByAuth(group.children, payload.topicSort);
        //console.log("AFTER sort", group.children.map(c=>c.auth));

        Vue.set(group, "topicSort", payload.topicSort);
        //console.log("group.topicSort", group.topicSort);

        sortAllContextsChildren(state.session.area, state.session.user);
        //sortContextChildren(group, state.session.area, state.session.user);

        // broadcast to subscribers of this
        const broadcast = [{
            entity: "group",
            auth: group.id,
        }];
        payload.broadcast = broadcast;
        console.log("broadcast", broadcast);
    },
    groupAssign: (state, payload) => {
        console.log("MUTATION group/assign", payload);
        if (!payload?.groupId) return;
        //if (!payload?.assigneeAuth&&!payload?.ownerAuth) return;

        const groupId = payload.groupId;
        const userAuth = payload.assigneeAuth;

        let userId = null;
        if (userAuth) {
            const user = state.session.area.users.find(el => el.id === userAuth);
            //console.log("USER FOUND", user);
            if (user) userId = user.id;
            else return;
        }

        let property = "userId";

        // update item in a area
        const items = state.session.area.groups;
        let item;
        if (items?.length) {
            item = items.find(el => el.id === groupId);
            if (item) item[property] = userId;
        }

        // update item in context
        if (state.page.context.group?.id === groupId) state.page.context.group[property] = userId;

        // broadcast to subscribers of this
        const broadcast = [{
            entity: "group",
            auth: payload?.groupId,
        }];
        payload.broadcast = broadcast;
        console.log("broadcast", broadcast);
    },
    groupAddUser: (state, payload) => {
        console.log("MUTATION group/addUser", payload);

        if (payload?.isFromServer) {
            applyContextUpdateFromPayload(state, payload);
            /*const groupId = payload.groupUpdate?.item?.id;
            // TODO make applyGroupUpdateFromPayload
            if (groupId) {
                console.log("GROUP ID", groupId);
                const group = state.session.area.groups?.find(el => el.id === groupId);
                console.log("GROUP", payload.groupUpdate?.item.userIds);
                if (group) Vue.set(group, "userIds", payload.groupUpdate?.item.userIds);
            }*/
        }
    },
    groupRemoveUser: (state, payload) => {
        console.log("MUTATION group/removeUser", payload);

        if (payload?.isFromServer) {
            applyContextUpdateFromPayload(state, payload);
            /*const groupId = payload.groupUpdate?.item?.id;
            if (groupId) {
                console.log("GROUP ID", groupId);
                const group = state.session.area.groups?.find(el => el.id === groupId);
                console.log("GROUP", payload.groupUpdate?.item.userIds);
                if (group) Vue.set(group, "userIds", payload.groupUpdate?.item.userIds);
            }*/
        }
    },
    groupMerge: (state, payload) => {
        console.log("MUTATION group/addUser", payload);

        if (payload?.isFromServer) {
            applyAreaUpdateFromPayload(state, payload);
        }
    },
    /*groupTariff: (state, payload) => {
        console.log("MUTATION group/tariff", payload);

        if (payload?.isFromServer) {
            const item = payload.groupUpdate?.item;
            if (item) {
                const group = state.session.area.groups?.find(el => el.auth === item.auth);
                if (group) group.tariffId = item.tariffId;
            }
        }
    },*/

    /**
     * @deprecated
     * @param state
     * @param payload
     */
    /*groupItem: (state, payload) => {
        console.log("MUTATION groupItem", payload);
        //console.log("\tpage data", data);
        if (!payload) return;
        /!*for (const key in payload) {
            Vue.set(state.ui, key, payload[key]);
        }*!/

        const group = state.page.context.group;
        if (group) {
            //storage.set(Config.STORAGE_GROUP_IDS, [group.id]);	// todo do we still need ids?
            if (typeof group.todoSort === "string") group.todoSort = JSON.parse(group.todoSort);
            if (typeof group.topicSort === "string") group.topicSort = JSON.parse(group.topicSort);
        }

        // clear pending items
        // small pause to make thins smoother
        setTimeout(() => {
            state.ui.pending.area = null;
            state.ui.pending.tab = null;
        }, 150);
    },*/
};

export default mutations;
